
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type LinkPreviewInfoLinkType = typeof LinkPreviewInfoLinkType[keyof typeof LinkPreviewInfoLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LinkPreviewInfoLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
